<template>
  <div class="container px-0 mb-5">
    <the-header />

    <b-card class="border-0 radius-top-0 mb-5" body-class="pt-0">
      <div v-if="state.loading" class="p-4 text-center text-muted">
        Carregando...
      </div>

      <div v-else>
        <div class="text-muted font-weight-medium h6 mb-3">Editar ação</div>
        <b-form @submit.prevent="onSubmit">
          <b-form-group
            v-if="planStructureName"
            label="Nível do Plano"
            label-class="font-weight-medium"
          >
            <b-form-input :value="planStructureName" disabled />
          </b-form-group>
          <form-list-actions v-model="state.form" :grid-mode="false" />
          <div class="row no-gutters mt-3">
            <b-button variant="primary" type="submit">
              Salvar
            </b-button>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive } from "vue";

import TheHeader from "@/modules/action_plans/components/TheHeader.vue";
import FormListActions from "@/modules/action_plans/components/Form/FormListActions.vue";

import { useRoute } from "@/composables/useRoute";
import { useRouter } from "@/composables/useRouter";
import { useMapActions } from "@/composables/useMapActions";
import { useRoot } from "@/composables/useRoot";

const route = useRoute();
const router = useRouter();
const root = useRoot();

const state = reactive({
  loading: true,
  form: {
    objectives: [],
  },
});

const idPlan = computed(() => route.params.id);

const { ActionGetOnePlan, ActionSave } = useMapActions("action_plans", [
  "ActionGetOnePlan",
  "ActionSave",
]);

const planStructureName = computed(() => {
  return (
    state.form?.planStructure?.name ||
    state.form?.plan_structure?.name ||
    state.form?.objective?.name ||
    "—"
  );
});

function ensurePlanStructureId() {
  if (state.form.plan_structure_id) return;
  if (state.form.planStructure?.id) {
    state.form.plan_structure_id = state.form.planStructure.id;
  } else if (state.form.plan_structure?.id) {
    state.form.plan_structure_id = state.form.plan_structure.id;
  }
}

function mapPlanToActionForm(plan) {
  return {
    ...plan,
    what: plan.what ?? plan.name ?? "",
    name: plan.name ?? plan.what ?? "",
    who_id: plan.who_id ?? plan.model_id ?? "",
    who_type: plan.who_type ?? plan.model_type ?? "organizational_structure",
    model_id: plan.model_id ?? plan.who_id ?? "",
    model_type: plan.model_type ?? plan.who_type ?? "organizational_structure",
    why: plan.why ?? "",
    where: plan.where ?? "",
    when: plan.when ?? "",
    when_start: plan.when_start ?? plan.when ?? "",
    how: plan.how ?? "",
    how_much: plan.how_much ?? "",
    action_plans_how_much: plan.action_plans_how_much ?? [],
    plan_structure_id:
      plan.plan_structure_id ??
      plan.planStructure?.id ??
      plan.plan_structure?.id ??
      null,
  };
}

function mapActionFormToPlan(form) {
  return {
    ...form,
    name: form.what ?? form.name ?? "",
    model_id: form.who_id ?? form.model_id ?? "",
    model_type: form.who_type ?? form.model_type ?? "organizational_structure",
  };
}

async function loadData() {
  state.loading = true;
  try {
    const planResult = await ActionGetOnePlan({ id: idPlan.value });
    const plan = planResult?.action_plan || {};
    state.form = mapPlanToActionForm(plan);
    ensurePlanStructureId();
  } finally {
    state.loading = false;
  }
}

async function onSubmit() {
  try {
    const title = state.form?.what ?? state.form?.name ?? "";
    if (!title || String(title).trim().length === 0) {
      root.$notifications.addNotification({
        message: "Informe o que será feito (O que?)",
        type: "danger",
      });
      return;
    }

    ensurePlanStructureId();

    if (!state.form.plan_structure_id) {
      root.$notifications.addNotification({
        message: "Nível do plano não encontrado",
        type: "danger",
      });
      return;
    }

    const payload = mapActionFormToPlan(state.form);
    payload.plan_structure_id = Number(state.form.plan_structure_id);

    await ActionSave(payload);

    root.$notifications.addNotification({
      message: "Registro atualizado com sucesso",
      type: "success",
    });

    router.push({ name: "show_action_plan", params: { id: idPlan.value } });
  } catch (error) {
    root.$notifications.addNotification({
      message: "Erro ao salvar",
      type: "danger",
    });
  }
}

onMounted(() => {
  loadData();
});
</script>

<style scoped lang="scss"></style>

